import { render, staticRenderFns } from "./Otoshi.vue?vue&type=template&id=7a280027&scoped=true&"
import script from "./Otoshi.vue?vue&type=script&lang=js&"
export * from "./Otoshi.vue?vue&type=script&lang=js&"
import style0 from "./Otoshi.vue?vue&type=style&index=0&id=7a280027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a280027",
  null
  
)

export default component.exports